import Http from '@/application/axios'
class HttpRequest {
    getApi(param) {
        return Http.get('/meeting/activity/info','', param);
    }
    postApi(param) {
        return Http.post('/counter/counter/getCounterPackageList', param);
    }
    //获取顶部轮播图方法
    getbanner(){
        return Http.get('/ymyp/door/getTopBannerList','')
    }
    //获取中间轮播图方法
    getCard(){
        return Http.get('/ymyp/door/getMiddleBannerList','')
    }
    getSubmission(param){
        return Http.post('/ymyp/door/saveIntention',param)
    }

    // 新闻接口
    getNewsList(param) {
        return Http.post('/ymyp/door/getNewsList', param);
    }
    // 获取新闻详情
    getNewsById(urlTemp,param) {
        return Http.get('/ymyp/door/getNewsById',urlTemp, param);
    }
}

export  default  HttpRequest
